import { RouterProvider } from 'react-router-dom';
import { message } from 'antd';
import { ToastContainer } from 'react-toastify';
import { routes } from '@/routes';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { PageHeaderProvider } from '@/contexts/PageHeaderContext';
import AuthBootstrap from '@/features/auth/components/AuthBootstrap';
import { configureAuthResponseInterceptor } from '@/features/auth/services/authInterceptor';

message.config({
  duration: 2,
  maxCount: 3,
});

configureAuthResponseInterceptor();

function App() {
  return (
    <AuthBootstrap>
      <PageHeaderProvider>
        <RouterProvider router={routes} />
        <ToastContainer
          position="bottom-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          pauseOnHover
          draggable
          theme="light"
        />
      </PageHeaderProvider>
    </AuthBootstrap>
  );
}

export default App;
